import { matchRoutes } from "react-router-dom";

const lcaShellRoutes = [
  { path: "/admin/apps/lca-assessment/*" },
  { path: "/org/apps/lca-assessment/*" },
];
const organizationShellRoutes = [{ path: "/org/*" }];
const platformShellRoutes = [{ path: "/admin/*" }];

export function isLcaLegacyShellPath(pathname: string): boolean {
  return matchRoutes(lcaShellRoutes, pathname) !== null;
}

export function usesClientPortalShell(
  role: string | null | undefined,
  pathname: string
): boolean {
  const isOrgPath = matchRoutes(organizationShellRoutes, pathname) !== null;
  return (
    isOrgPath &&
    (role === "ORG_OWNER" || role === "ORG_ADMIN") &&
    !isLcaLegacyShellPath(pathname)
  );
}

/**
 * Platform-owner/admin counterpart to `usesClientPortalShell`: every `/admin/*`
 * route except the LCA administration route family (and its route-normalized
 * variants, handled identically by `isLcaLegacyShellPath`), which keeps the
 * legacy Sidebar shell unchanged.
 */
export function usesPlatformPortalShell(
  role: string | null | undefined,
  pathname: string
): boolean {
  const isPlatformPath = matchRoutes(platformShellRoutes, pathname) !== null;
  return (
    isPlatformPath &&
    (role === "PLATFORM_OWNER" || role === "PLATFORM_ADMIN") &&
    !isLcaLegacyShellPath(pathname)
  );
}
